

<script>
    import {mapGetters} from 'vuex'
    import {featuresForAccount as _featuresForAccount} from '@/store/modules/accounts'
    import {providerConfig} from '@/components/QualityChecks/qualityCheckProviders'
    export default {
        computed: {
            ...mapGetters({
                // account: 'account',
                apis: 'externalApis',
                subscriptions: 'subscriptions', features: 'features', currentAccountFeatureData: 'currentAccountFeatureData'
            }),
            /**
             * DEV-2885: which provider's checks this list manages.
             *
             * Reads `this.provider` from the mixing component, which may not declare one —
             * OAuth.vue mixes this in purely to seed checks straight after a Proofpoint connect
             * and has no provider prop. `providerConfig` falls back to Proofpoint, so that path
             * is unchanged.
             */
            qualityProvider() {
                return providerConfig(this.provider)
            },
            authenticatedProvider() {
                const api = this.apis[this.qualityProvider.apiName]
                return api && api[this.account.id]
            },
            canCreateQualityChecks() {
                return this.authenticatedProvider
                    && this.featuresForAccount[this.qualityProvider.featureKey]
                    && this.featuresForAccount.qualityChecks
            },
            featuresForAccount() {
                return _featuresForAccount(this.subscriptions, this.features, this.currentAccountFeatureData)(this.account)
            }
        },
        methods: {
            async fetchChecks() {
                // Filter to this provider's checks. Without this, an account with both providers
                // would show every check under both tabs and edits would cross over.
                return await this.$api.get(`/accounts/${this.account.id}/quality-checks`)
                    .then(r => (r.data || []).filter(c => c.type === this.qualityProvider.key));
            },
            async initializeChecks() {
                console.log('fetchChecksAndInitializeDoNotExist', this.canCreateQualityChecks)
                if (!this.canCreateQualityChecks) return false;
                // DEV-2885: Theta Lake does not auto-seed. Opening the tab must not create a check
                // the user did not ask for — the story is "I would like to *create* quality
                // checks", and there is no default concept to seed. Proofpoint is unaffected.
                if (!this.qualityProvider.autoSeedDefaultCheck) return false;
                await this.$api.post(`/accounts/${this.account.id}/quality-checks`, {
                    name: this.qualityProvider.defaultCheckName,
                    default: true,
                    type: this.qualityProvider.key,
                    meta: this.qualityProvider.newCheckMeta()
                });
            },
            async fetchStatuses(check) {
                return await this.$api.get(`/quality-checks/${check.id}/statuses`).then(r => r.data||[])
            },
            async initializeStatuses(check) {
                // `type` decides which provider's default statuses the server creates. Before
                // DEV-2885 the endpoint required it and ignored it, always seeding Proofpoint's.
                // Taken from the check itself rather than the active tab, so a check is always
                // seeded for its own provider.
                return await this.$api.put(`/quality-checks/${check.id}/statuses/initialize`, {
                    type: check.type || this.qualityProvider.key
                });
            },
            /**
             * Backfill `meta` on a check fetched from the API so the form can bind to it.
             *
             * Only fills in what the check's own provider actually uses. Proofpoint needs
             * `external_ids` because the form v-models into it; Theta Lake has no such field, and
             * creating an empty one there would send back settings nothing can set.
             */
            async upgradeCheck(c) {
                if (!c.meta)
                    c.meta = {};

                const config = providerConfig(c.type || this.qualityProvider.key);
                if (config.showConfigExternalId && !c.meta.external_ids)
                    c.meta.external_ids = {
                        success_flag: null,
                        flag_fail: null
                    }
            },
            async fetchChecksAndInitializeDoNotExist() {
                console.log('fetchChecksAndInitializeDoNotExist')
                let checks = await this.fetchChecks();
                if (!checks || !checks.length) {
                    await this.initializeChecks();
                    checks = await this.fetchChecks();
                }
                await Promise.all(checks.map(async check => {
                    check.statuses = await this.fetchStatuses(check);
                    if (!check.statuses || !check.statuses.length) {
                        await this.initializeStatuses(check);
                        check.statuses = await this.fetchStatuses(check);
                    }
                }));
                checks.forEach(c => this.upgradeCheck(c));
                return checks;
            }
        }
    }
</script>
